var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { TrapFocus } from '../../TrapFocus/index.js';
export const ModalPanel = forwardRef((_a, ref) => {
    var { children, size = 'lg', className, zenMode = false } = _a, rest = __rest(_a, ["children", "size", "className", "zenMode"]);
    const widthClsx = [
        'w-full',
        !zenMode && [
            size === 'md' && 'sm:max-w-md',
            size === 'lg' && 'sm:max-w-lg',
            size === 'xl' && 'sm:max-w-xl',
            size === '2xl' && 'sm:max-w-2xl',
            size === '3xl' && 'sm:max-w-3xl',
            size === '5xl' && 'sm:max-w-5xl',
            size === 'fit' && 'sm:max-w-fit',
            size === 'full' && 'sm:w-full',
        ],
    ];
    const heightClsx = [
        'max-h-screen',
        zenMode ? 'min-h-screen' : 'min-h-screen sm:min-h-0',
        size === 'full' ? 'h-full' : 'h-full sm:max-h-[calc(100vh-2rem)]',
    ];
    return (React.createElement("div", Object.assign({ ref: ref, role: "dialog", "aria-modal": true, className: clsx('relative pointer-events-auto', 'bg-surface text-content-subdued', !zenMode && 'sm:rounded-lg', 'overflow-y-auto overscroll-contain', 'flex flex-col mx-auto', widthClsx, heightClsx, 'shadow-xl transform transition-all', className) }, rest),
        React.createElement(TrapFocus, null, children)));
});
//# sourceMappingURL=ModalPanel.js.map